function shuffleFeaturedSliders() {
  document.querySelectorAll(".wt-featured-collection [data-swiper]").forEach(function (sliderRoot) {
    var container = sliderRoot.querySelector("[data-swiper-container]");
    if (!container) return;

    var slides = Array.prototype.slice.call(
      container.querySelectorAll(":scope > [data-swiper-slide]")
    );
    if (slides.length < 2) return;

    // Fisher-Yates shuffle over the full rendered pool
    for (var i = slides.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = slides[i];
      slides[i] = slides[j];
      slides[j] = tmp;
    }

    // How many slides should remain visible
    var sectionEl = sliderRoot.closest("slideshow-section");
    var showCount = parseInt(sectionEl && sectionEl.dataset.productsToShow, 10) || slides.length;

    // Build fragment of only the first showCount slides
    var frag = document.createDocumentFragment();
    slides.slice(0, showCount).forEach(function (slide) {
      frag.appendChild(slide);
    });

    // Re-attach survivors, then remove any surplus slides still in the DOM
    container.appendChild(frag);
    slides.slice(showCount).forEach(function (slide) {
      slide.remove();
    });
  });
  console.log("shuffle ran");
}

shuffleFeaturedSliders();